import queryString from 'query-string';

export const pageFromQuery = (searchString) => {
  const { page } = queryString.parse(searchString);
  return page;
};

export const concatUrlString = (page) => {
  let urlString;
  if (page && page > 1) {
    urlString = `page=${page}`;
  }
  return urlString;
};

export const queryStringFromProps = (props) => {
  const { location } = props;
  const queryObj = queryString.parse(location.search);
  const { page } = queryObj;
  if (page && page > 1) {
    return `page=${page}`;
  }
  return null;
};

export const urlPushQuery = (listUrl, qString) => {
  let url = listUrl;
  if (qString) {
    url = `${listUrl}?${qString}`;
  }
  return url;
};
